export function getFinancialApiUrl() {
    const config = {
        local: 'https://financialapi.dev.lendingtree.com/graphql',
        prod: 'https://financialapi.lendingtree.com/graphql',
        dev: 'https://financialapi.dev.lendingtree.com/graphql',
        stage: 'https://financialapi.staging.lendingtree.com/graphql',
    }[process.env.LT_ENV || 'dev'];
    return config;
}

function getFinancialApiKey() {
    const config = {
        local: 'py6tg2hys69kqmc1ayvrfs6w',
        prod: 'yq8uh2kw51mbpzas89ewdgf4',
        dev: 'kjh7ygtr5edf2jhnbdukmwo2',
        stage: 'py6tg2hys69kqmc1ayvrfs6w',
    }[process.env.LT_ENV || 'dev'];
    return config;
}

export const setHeader = { 'x-lendingtree-financial': getFinancialApiKey() };
